var map = {
	"./JSDomEnvironment": 562,
	"./JSDomEnvironment.js": 562
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1502;



//////////////////
// WEBPACK FOOTER
// ./~/jest-cli/src/__mocks__ ^\.\/.*$
// module id = 1502
// module chunks = 0